export default __webpack_public_path__ + "static/media/9 raw.cabec754.mp3";